var exports = {
  "au": "AnchorRegion__lFFy5k",
  "Op": "LinkPopover__kfrGFi",
  "Vj": "LinkPopoverUrl__5-Z_KL",
  "ns": "LinkPopoverMetadata__IFygD_",
};

module.exports = exports;
